import Vue from 'vue'
import transactions from './transactions'

const modules = {
  transactions
}

const state = {
  datasetKey: '0',
  currentDataset: {},
  datasetEdits: {},
  topFieldsInvalid: false
}

export const getters = {
  getDatasetKey: state => state.datasetKey,
  datasetName: state => state.currentDataset.dataset_name,
  getCurrentDataset: state => state.currentDataset,
  getTopLevelFields: state => {
    return {
      dataset_name: state.currentDataset.dataset_name,
      dataset_desc: state.currentDataset.dataset_desc,
      create_date: state.currentDataset.create_date
    }
  },
  getDatasetEdits: state => state.datasetEdits,
  datasetDesc: state => state.currentDataset.dataset_desc,
  datasetCreateDate: state => state.currentDataset.create_date,
  datasetWebsite: state => state.currentDataset.dataset_website,
  datasetRepo: state => state.currentDataset.dataset_repo,
  datasetDataset: state => state.currentDataset.dataset_dataset,
  datasetReadme: state => state.currentDataset.dataset_readme,
  datasetAccess: state => state.currentDataset.dataset_access,
  datasetLicense: state => state.currentDataset.dataset_license,
  isDatasetEmpty: state => Object.keys(state.currentDataset).length === 0,
  getTopFieldsInvalid: state => state.topFieldsInvalid
}

export const mutations = {
  setDataset (state, payload) {
    state.currentDataset = payload
  },
  setDatasetKey (state, key) {
    state.datasetKey = key
  },
  setDatasetEdits (state, dataset) {
    Vue.set(state.datasetEdits, 'dataset_name', dataset['dataset_name'])
    Vue.set(state.datasetEdits, 'dataset_desc', dataset['dataset_desc'])
    Vue.set(state.datasetEdits, 'dataset_license', dataset['dataset_license'])
    Vue.set(state.datasetEdits, 'dataset_website', dataset['dataset_website'])
    Vue.set(state.datasetEdits, 'dataset_repo', dataset['dataset_repo'])
    Vue.set(state.datasetEdits, 'dataset_dataset', dataset['dataset_dataset'])
    Vue.set(state.datasetEdits, 'dataset_readme', dataset['dataset_readme'])
    Vue.set(state.datasetEdits, 'dataset_access', dataset['dataset_access'])
  },
  setTopFieldsInvalid (state, payload) {
    state.topFieldsInvalid = payload
  },
  setDataFormats (state, payload) {
    state.currentDataset.dataset_dataformat = payload
  },
  addItemMut (state, payload) {
    state.currentDataset[payload.array].push(payload.item)
  },
  removeItemMut (state, payload) {
    let arr = state.currentDataset[payload.array].filter(item => item.key !== payload.key)
    Vue.set(state.currentDataset, payload.array, arr)
  },
  removeFileMut (state, payload) {
    let arr = state.currentDataset[payload.array].filter(item => item.media_url !== payload.key)
    Vue.set(state.currentDataset, payload.array, arr)
  },
  addDataFormatMut (state, payload) {
    state.currentDataset.dataset_dataformat.push(payload)
  },
  setDatasetEdit (state, payload) {
    state.datasetEdits[payload.key] = payload.value
  }
}

export default {
  modules,
  state,
  getters,
  mutations
}
